var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PayPalCasesCreationSection',{attrs:{"PC":_vm.PC,"createData":_vm.createData},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }